import { render, staticRenderFns } from "./diseaseTypelist.vue?vue&type=template&id=6b9ed792&"
import script from "./diseaseTypelist.vue?vue&type=script&lang=js&"
export * from "./diseaseTypelist.vue?vue&type=script&lang=js&"
import style0 from "./diseaseTypelist.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports